import { all, call, put, takeLatest } from "redux-saga/effects";
import { FETCH_ADVERTISEMENTS,
  fetchAdvertisementsFailure,
  fetchAdvertisementsRequested,
  fetchAdvertisementsSuccess } from "../actions/ads-action-types";
import httpClient from "./http-client";

export function* fetchAdsHandler() {
  yield put(fetchAdvertisementsRequested());

  const request = {
    method: "GET",
    url: "/api/v1/ads",
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(fetchAdvertisementsFailure(error));
  } else {
    yield put(fetchAdvertisementsSuccess(data.details));
  }
}

function* Advertisements() {
  yield all([
    takeLatest(FETCH_ADVERTISEMENTS, fetchAdsHandler),
  ]);
}

export default Advertisements;
